export default {
  'article.title': 'AllChinaBuy Spreadsheet: Complete Guide to Product Finds & Categories',
  'article.updated': 'Last updated',
  'article.author': 'Written by the AllChinaBuy Spreadsheet editorial team',
  'article.readTime': '8 min read',

  'article.quickAnswer.label': 'Quick Answer',
  'article.quickAnswer.text': 'The AllChinaBuy Spreadsheet is a curated collection of product finds organized by category. It helps shoppers quickly discover items across shoes, clothing, bags, accessories and more, so you can compare options and plan your purchases in one place.',

  'article.toc.title': 'On this page',

  'article.s1.title': 'What Is the AllChinaBuy Spreadsheet?',
  'article.s1.p1': 'An AllChinaBuy spreadsheet is a simple, organized way to browse product ideas without scrolling through endless pages. Instead of guessing where to look, the spreadsheet groups finds into clear categories such as shoes, hoodies, t-shirts, jackets, pants and accessories.',
  'article.s1.p2': 'Think of it as a starting point for product research. It points you toward categories and items that other shoppers are exploring, while leaving the final decision — and the purchase — up to you. It is an independent resource, not an official tool.',

  'article.s2.title': 'How to Use the Spreadsheet for Product Research',
  'article.s2.p1': 'You do not need any special skills to get started. The basic workflow is simple and repeatable.',
  'article.s2.li1': 'Pick a category — start with the type of product you want, like shoes or bags.',
  'article.s2.li2': 'Browse the finds — look through the items listed under that category.',
  'article.s2.li3': 'Compare options — note the styles, colors and details that stand out.',
  'article.s2.li4': 'Visit the main site — follow the category link to explore full listings and make a purchase.',

  'article.s3.title': 'Understanding the Product Categories',
  'article.s3.p1': 'The spreadsheet covers the most popular AllChinaBuy categories, so you can jump straight to the section that matters to you.',
  'article.s3.p2': 'Categories include shoes, hoodies and sweaters, t-shirts, jackets, pants and shorts, headwear, sets, underwear, jerseys, accessories, bags, belts, perfumes and other miscellaneous items. Each category links directly to the matching section of the main website.',

  'article.s4.title': 'Tips for Finding Quality Products',
  'article.s4.p1': 'A little patience goes a long way when browsing finds. Here are a few habits that help.',
  'article.s4.li1': 'Check multiple listings before deciding.',
  'article.s4.li2': 'Look for clear product photos and detailed descriptions.',
  'article.s4.li3': 'Consider sizing and measurements carefully, especially for clothing and shoes.',
  'article.s4.li4': 'Save interesting finds so you can compare them later.',

  'article.s5.title': 'A Note on QC and Sellers',
  'article.s5.p1': 'Quality control and seller reliability matter for any online purchase. Whenever possible, review seller feedback and product photos, and pay attention to shipping options and estimated delivery times before you order.',
  'article.s5.p2': 'Remember that this resource is for information and discovery. Always do your own checks and buy from sources you trust.',

  'article.faq.title': 'Frequently Asked Questions',
  'article.faq.q1': 'Is this an official AllChinaBuy website?',
  'article.faq.a1': 'No. This is an independent informational resource. It is not operated by or affiliated with AllChinaBuy.',
  'article.faq.q2': 'Is the AllChinaBuy Spreadsheet free to browse?',
  'article.faq.a2': 'Yes, the category links and guides here are free to explore. Purchases take place on the main website.',
  'article.faq.q3': 'How do I find a specific product?',
  'article.faq.a3': 'Choose the closest category from the dropdown or buttons, then browse the linked listings on the main site.',
  'article.faq.q4': 'How often is the spreadsheet updated?',
  'article.faq.a4': 'We aim to keep categories and guides current. Check back regularly for the latest finds and tips.',

  'article.related.title': 'Related Resources',
  'article.related.home': 'Back to the AllChinaBuy Spreadsheet homepage',

  'article.cta.title': 'Ready to Explore the AllChinaBuy Spreadsheet?',
  'article.cta.subtitle': 'Browse categories and product finds, or head straight to the main website to shop.',
  'article.cta.button1': 'Explore Spreadsheet',
  'article.cta.button2': 'Visit Main Website',
  'article.backHome': 'Back to homepage',
};